<!-- <div class="home">
  <div class="logo-container">
    <img src="../../../assets/img/AV.png" class="app-logo">
    <img src="../../../assets/img/av_park_linear_green4.png" class="co-logo">
  </div>
</div> -->

<app-title-bar titleText="i18n.core.navigation.home"></app-title-bar>

<app-dashboard-oversight></app-dashboard-oversight>


